import { firestoreAction } from 'vuexfire'
import * as firebase from 'firebase'
import db from '@/db'

const redFlagsRef = db.collection('redFlags')
const orgRef = db.collection('organization')
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const initialState = {
  redFlags: [],
  redFlagLoading: true
}

const state = Object.assign({}, initialState)

const mutations = {
  'SET_RED_FLAG_LOADING' (state, loading) {
    state.redFlagLoading = loading
  },
  'RESET_STATE' (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  }
}

const actions = {
  resetRedFlagState: firestoreAction(({ commit, unbindFirestoreRef }) => {
    unbindFirestoreRef('redFlags')
    commit('RESET_STATE')
  }),
  setRedFlagsRef: firestoreAction(({ bindFirestoreRef, commit, dispatch }, ref) => {
    bindFirestoreRef('redFlags', ref).then(response => {
      commit('SET_RED_FLAG_LOADING', false)
      dispatch('toggleLoading', false)
    }).catch(error => {
      console.log(error)
    })
  }),
  addRedFlag: ({ dispatch }, payload) => {
    let flag = { ...payload }
    return new Promise((resolve, reject) => {
      redFlagsRef.add(flag).then(entry => {
        const id = entry.id
        let flagInfo = {
          updated: updated
        }
        const flagKey = 'redFlags.' + id
        flagInfo[flagKey] = true
        orgRef.doc(payload.organization).update(flagInfo).then(response => {
          dispatch('getRoles', id).then(response => {
            resolve(id)
          })
          dispatch('saveState', true)
        }).catch(error => {
          console.log(error)
        })
      }, error => {
        reject(error)
      })
    })
  },
  getRoles: ({ getters, rootGetters }, flag) => {
    const redFlag = getters.redFlag(flag)
    let rolesList = {}
    rootGetters.roles.forEach(roles => {
      const key = roles.id
      rolesList[key] = {
        impact: 0
      }
    })
    const updatedRoles = Object.assign({}, rolesList, redFlag.roles)
    redFlagsRef.doc(flag).update({ 'roles': updatedRoles })
  },
  editRedFlag: ({ dispatch }, payload) => {
    const flag = payload.id
    const updatedFlag = { ...payload }
    updatedFlag.updated = updated
    Object.keys(updatedFlag).forEach(key => updatedFlag[key] === undefined && delete updatedFlag[key])
    redFlagsRef.doc(flag).update(updatedFlag).then(response => {
      dispatch('saveState', true)
    })
  },
  archiveRedFlag: ({ dispatch }, id) => {
    const update = {
      updated: updated,
      archived: updated
    }
    redFlagsRef.doc(id).update(update).then(response => {
      dispatch('saveState', true)
    }).catch(error => {
      console.log(error)
    })
  },
  duplicateRedFlag: ({ dispatch }, payload) => {
    const redFlagData = { ...payload }
    redFlagData.title = payload.title + ' copy'
    redFlagData.updated = updated
    redFlagData.created = updated
    return new Promise((resolve, reject) => {
      redFlagsRef.add(redFlagData).then(entry => {
        const id = entry.id
        let flagInfo = {
          updated: updated
        }
        const flagKey = 'rates.' + id
        flagInfo[flagKey] = true
        orgRef.doc(payload.organization).update(flagInfo).then(response => {
          resolve(id)
        }).catch(error => {
          console.log(error)
        })
        setTimeout(delay => {
          dispatch('saveState', true)
          dispatch('toggleLoading', false)
        }, 2000)
      }, error => {
        reject(error)
      })
    })
  },
  duplicateRedFlags: ({ dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      const oldFlags = { ...state.redFlags }
      const rfMatrix = {}
      const batch = db.batch()
      let flagCount = 0
      Object.keys(oldFlags).forEach(flag => {
        const newFlag = { ...oldFlags[flag] }
        const oldFlag = oldFlags[flag].id
        delete newFlag.id
        newFlag.owner = payload.user
        newFlag.created = updated
        newFlag.updated = updated
        newFlag.organization = payload.org
        if (newFlag.roles) {
          const newRoles = {}
          Object.keys(newFlag.roles).forEach(role => {
            const key = payload.roles[role]
            if (newFlag.roles[role].impact) {
              newRoles[key] = {
                impact: newFlag.roles[role].impact
              }
            } else {
              newRoles[key] = {
                impact: 0
              }
            }
          })
          newFlag.roles = newRoles
        }
        redFlagsRef.add(newFlag).then(reference => {
          rfMatrix[oldFlag] = reference.id
          const org = orgRef.doc(payload.org)
          const orgKey = 'redFlags.' + reference.id
          const orgInfo = {}
          orgInfo[orgKey] = true
          batch.update(org, orgInfo)
          flagCount++
          if (flagCount === state.redFlags.length) {
            commitBatch()
          }
        }).catch(error => {
          console.log(error)
        })
      })
      function commitBatch () {
        batch.commit().then(response => {
          resolve(rfMatrix)
        }, error => {
          reject(error)
        })
      }
    }).catch(error => {
      console.log(error)
    })
  }
}

const getters = {
  redFlagLoading: state => {
    return state.redFlagLoading
  },
  redFlags: (state, rootGetters) => {
    return state.redFlags.filter(redFlag => redFlag.archived === false)
  },
  redFlag: state => (key) => {
    return state.redFlags.find(redFlags => redFlags.id === key)
  },
  latestRedFlag: state => {
    const rfCount = state.redFlags.filter(roles => roles.archived === false).length - 1
    return state.redFlags[rfCount]
  },
  redFlagImpact: (state, rootGetters) => (key) => {
    const redFlag = state.redFlags.find(redFlags => redFlags.id === key)
    const accent = rootGetters.organization.theme.accent
    let labels = []
    let data = []
    if (redFlag.roles) {
      Object.keys(redFlag.roles).forEach(roleId => {
        const role = rootGetters.role(roleId)
        labels.push(role.name)
        data.push(redFlag.roles[roleId].impact)
      })
    }
    return {
      labels: labels,
      datasets: [{
        data: data,
        borderColor: accent,
        backgroundColor: accent
      }]
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
